import type { Component, Entity2D } from '../../odie';

import { DirectionBlockOptionDef, DogBlockProps } from '../defs/block';
import { DogBlockView } from '../views/blocks/DogBlockView';

// types
//-----------------------------------------------------------------------------
export type DogBlockComponentOptions = {
  props: DogBlockProps;
  option?: number;
};

/*
    dog block component
*/
export class DogBlockComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockDog';

  // fields
  //-------------------------------------------------------------------------
  private props!: DogBlockProps;
  // injected
  public entity!: Entity2D;
  // scene
  public view!: DogBlockView;

  // impl
  //-------------------------------------------------------------------------
  public init(options: DogBlockComponentOptions): void {
    // get option def
    const optionDef = options.props.options?.[
      options.option || 0
    ] as DirectionBlockOptionDef;

    this.props = options.props;

    // create view
    this.view = new DogBlockView(options.props);

    // set initial direction
    this.view.direction = optionDef.direction;

    // Set the getGameplayState retrieval function
    this.entity.c.block.getGameplayState = () => this.getGameplayState();
  }

  public getGameplayState(): number {
    const options = this.props.options as DirectionBlockOptionDef[];
    return options.findIndex((opt) => {
      return opt.direction === this.view.direction;
    });
  }
}
